// @ts-nocheck
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  base: __dirname,
  //路由映射map
  routes: [
    { path: '/', redirect: '/index/login'},
    { path: '*', redirect: '/index/login' },
    {
      path: '/index',
      name: 'index',
      component:  resolve => require(["@/components/index"], resolve),
      children:[
        {
          path: '/index/login',
          name: 'login',
          component:  resolve => require(["@/components/login"], resolve),
        },
        {
          path: '/index/home',
          name: 'home',
          component:  resolve => require(["@/components/home"], resolve),
        },
      ]
    },
  ]
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js